export enum SupportedLang {
  EN = 'en',
  DE = 'de',
  FR = 'fr',
  IT = 'it',
}
